import { useState } from 'react';
import type { Partner } from '../../types/api';
import { Eyebrow, Reveal } from '../ui';

function Logo({ p }: { p: Partner }) {
  const [failed, setFailed] = useState(false);
  const img = p.image?.url && !failed ? (
    <img src={p.image.url} alt="" loading="lazy" onError={() => setFailed(true)} className="max-h-full max-w-full object-contain" />
  ) : null;
  const inner = (
    <>
      <div className="flex aspect-[4/3] items-center justify-center bg-surface p-8">{img ?? <span className="font-display text-2xl font-bold text-muted">{p.name.charAt(0)}</span>}</div>
      <div className="mt-4 font-sans text-[1.0625rem] font-semibold leading-snug text-black">{p.name}</div>
    </>
  );
  return p.website ? <a href={p.website} target="_blank" rel="noopener noreferrer" className="block transition-opacity hover:opacity-80">{inner}</a> : <div>{inner}</div>;
}

/** Logos en grille de 4 colonnes, nom en légende (équivalent de « Distinctions » de la référence, avec tes partenaires). */
export default function LogoGrid({ eyebrow, partners }: { eyebrow: string; partners: Partner[] }) {
  const list = partners.filter((p) => p.enable !== false);
  if (list.length === 0) return null;
  return (
    <section className="bg-white py-16 text-black md:py-28">
      <div className="site-container">
        <Eyebrow className="mb-12">{eyebrow}</Eyebrow>
        <ul className="grid gap-x-6 gap-y-12 sm:grid-cols-2 lg:grid-cols-4">
          {list.map((p, i) => <li key={p.id}><Reveal delay={(i % 4) * 0.06}><Logo p={p} /></Reveal></li>)}
        </ul>
      </div>
    </section>
  );
}
